<template>
  <div>
    <!-- <v-row>
      <span>
        <v-col cols="12" xs="12" sm="12">
          <p class="slide">
            Image size should be less than {{ allowed_size / 1000000 }}MB!
          </p>
        </v-col>
      </span>
      <span>
        <v-col cols="12" xs="12" sm="12">
          <p class="slide">
            Image should be in
            <span v-for="(type, index) in allowed_extensions" in :key="index">
              {{ type }}</span
            >
            Format!
          </p>
        </v-col>
      </span>
    </v-row> -->
    <v-row dense>
      <span class="slide">
        Note* : Image size should be less than {{ allowed_size / 1000000 }}MB!
        and Image should be in
        <span v-for="(type, index) in allowed_extensions" in :key="index">
          {{ type }}</span
        >
        Format!
      </span>
    </v-row>
    <br>
    <v-row>
      <v-col cols="12" lg="2" sm="2"></v-col>
      <v-col cols="12" lg="4" sm="4">
        <!-- new code -->
         <label><b>Profile Image</b></label>
        <div v-if="file_path != 'NA'">
          <center>
            <img :src="aws_path + file_path" width="200px" height="200px" />
            <br />
            <v-btn
              class="mx-2"
              fab
              dark
              small
              color="primary"
              @click="downloadImage(aws_path + file_path)"
            >
              <v-icon>mdi-download</v-icon></v-btn
            >
            <a target="_blank" :href="aws_path + file_path" download="myimage"
              ><v-icon>mdi-download</v-icon></a
            >
          </center>
        </div>
        <!-- new code end -->
        <!-- <v-card class="mx-auto" max-width="200px" v-if="file_path != 'NA'">
          <v-img height="200px" :src="aws_path + file_path"> </v-img>
          <center>
            <a target="_blank" :href="aws_path + file_path" download="myimage"
              ><v-icon>mdi-download</v-icon></a
            >
          </center>
        </v-card> -->
        <v-card class="mx-auto" max-width="200px" v-else>
          <!-- <v-img height="200px" src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/logo/e-learning.png"> </v-img> -->
          <v-img
            height="200px"
            src="https://eduplusschool.s3.ap-south-1.amazonaws.com/avatar.jpeg"
          >
          </v-img>
        </v-card>
        <v-row class="justify-center">
          <v-file-input
            id="newFile"
            v-model="profile_image"
            accept="image/*"
            style="display: none"
            @change="validateImage(profile_image, 'profile')"
          ></v-file-input>
          <label class="mt-5" for="newFile">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="img-plus mdi mdi-cloud-upload"
                  color="#0f2027"
                  v-bind="attrs"
                  v-on="on"
                ></v-icon>
              </template>
              <span>Upload profile picture</span>
            </v-tooltip>
          </label>
        </v-row>

        <v-row justify="center">
          <span v-if="profile_image != null" style="color: green">{{
            profile_image.name
          }}</span>
        </v-row>
      </v-col>
       <v-col cols="12" lg="4" sm="4">
        <!-- new code -->
         <label><b>Signature</b></label>
        <div v-if="signature_path != 'NA'">
          <center>
            <img :src="aws_path + signature_path" width="200px" height="200px" />
            <br />
            <v-btn
              class="mx-2"
              fab
              dark
              small
              color="primary"
              @click="downloadImage(aws_path + signature_path)"
            >
              <v-icon>mdi-download</v-icon></v-btn
            >
            <a target="_blank" :href="aws_path + signature_path" download="myimage"
              ><v-icon>mdi-download</v-icon></a
            >
          </center>
        </div>
        <v-card class="mx-auto" max-width="200px" v-else>
          <v-img
            height="200px"
            src="https://eduplusschool.s3.ap-south-1.amazonaws.com/avatar.jpeg"
          >
          </v-img>
        </v-card>
        <v-row class="justify-center">
          
          <v-file-input
            id="newFile1"
            v-model="sign_image"
            accept="image/*"
            style="display: none"
            @change="validateImage(sign_image, 'sign')"
          ></v-file-input>
          <label class="mt-5" for="newFile1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="img-plus mdi mdi-cloud-upload"
                  color="#0f2027"
                  v-bind="attrs"
                  v-on="on"
                ></v-icon>
              </template>
              <span>Upload Sign</span>
            </v-tooltip>
          </label>
        </v-row>

        <v-row justify="center">
          <span v-if="sign_image != null" style="color: green">{{
            sign_image.name
          }}</span>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <div class="text-center">
        <v-btn class="button" small @click="saveImage">Upload</v-btn>
      </div>
    </v-row>
    <div class="text-center">
      <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please wait..
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-dialog v-model="image_valid" width="400px">
        <v-card>
          <v-col cols="12" sm="12" md="12">
            <v-row justify="center" dense>
              <span v-if="size_flag == true">
                <v-alert type="error" dense outlined prominent>
                  Image size should be less than
                  {{ allowed_size / 1000000 }}MB!
                </v-alert>
              </span>
              <span v-if="ext_flag == true">
                <v-alert type="error" dense outlined prominent>
                  Image should be in
                  <span
                    v-for="(type, index) in allowed_extensions"
                    in
                    :key="index"
                  >
                    {{ type }}</span
                  >
                </v-alert>
              </span>
              <v-btn class="button" small @click="image_valid = false">
                Cancel
              </v-btn>
            </v-row>
          </v-col>
          <v-card-actions>
            <center></center>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="cropDialog" max-width="700px">
      <v-card>
        <v-card-title>Crop Image</v-card-title>

        <v-card-text>
          <div
            ref="imageContainer"
            style="position: relative; display: inline-block;"
          >
            <img
              ref="cropImage"
              :src="cropImageSrc"
              style="max-width:100%; display:block;"
            />

            <!-- Movable Square -->
            <div
      class="crop-box"
      :style="cropStyle"
      @mousedown.prevent="startMove"
    >
      <!-- Sides -->
      <div class="resize top" @mousedown.stop.prevent="startResize('top')"></div>
      <div class="resize bottom" @mousedown.stop.prevent="startResize('bottom')"></div>
      <div class="resize left" @mousedown.stop.prevent="startResize('left')"></div>
      <div class="resize right" @mousedown.stop.prevent="startResize('right')"></div>

      <div class="corner top-left" @mousedown.stop.prevent="startResize('top-left')">
        <span class="hor"></span>
        <span class="ver"></span>
      </div>
      <div class="corner top-right" @mousedown.stop.prevent="startResize('top-right')">
        <span class="hor"></span>
        <span class="ver"></span>
      </div>
      <div class="corner bottom-left" @mousedown.stop.prevent="startResize('bottom-left')">
        <span class="hor"></span>
        <span class="ver"></span>
      </div>
      <div class="corner bottom-right" @mousedown.stop.prevent="startResize('bottom-right')">
        <span class="hor"></span>
        <span class="ver"></span>
      </div></div>

          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="applySquareCrop">Crop</v-btn>
          <v-btn text @click="cropDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import moment from "moment";

export default {
  props: {
    instid: Number,
  },
  data() {
    return {
      aws_path: null,
      file_path: null,
      signature_path: null,
      profile_image: null,
      sign_image: null,
      dialog_upload: false,
      allowed_extensions: [],
      allowed_size: 0,
      showFlag: false,
      size_flag: false,
      ext_flag: false,
      image_valid: false,
      cropDialog: false,
      cropImageSrc: null,
      currentType: null,
      cropTop: 0,
      cropLeft: 0,
      cropWidth: 200,
      cropHeight: 200,
      resizing: null,


    };
  },
  watch: {
    instid() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    downloadImage(url) {
      fetch(url)
        .then((resp) => resp.blob())
        .then((blobobject) => {
          const blob = window.URL.createObjectURL(blobobject);
          const anchor = document.createElement("a");
          anchor.style.display = "none";
          anchor.href = blob;
          anchor.download = "name.png";
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(blob);
        })
        .catch(() => alert("An error in downloading the file sorry"));
    },
   
    // downloadImage1(url) {
    //   axios({
    //     url: url,
    //     method: "GET",
    //     responseType: "blob",
    //   }).then((response) => {
    //     var fileUrl = window.URL.createObjectURL(new Blob([response.data]));
    //     var fileLink = document.createElement("a");
    //     fileLink.href = fileUrl;

    //     fileLink.setAttribute("download", "image.jpg");
    //     document.body.appendChild(fileLink);

    //     fileLink.click();
    //   });
    // },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getData() {
      const formData = {
        instid: this.instid,
      };
      axios
        .post("/EmployeeProfile/getEmployeePicture", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.aws_path = res.data.aws_path;
            this.file_path = res.data.file_path;
            this.signature_path = res.data.signature_path;
            this.allowed_size = res.data.sizelimit;
            this.allowed_extensions = res.data.allowed_extensions;
          } else {
            // alert("Somthing went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Someting went wrong!!!");
          // alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },

    validateImage(image, type) {
      if (!image) return;

      let file_size = image.size;
      let ext = image.name.split(".").pop().toLowerCase();

      // Size validation
      if (file_size > this.allowed_size) {
        this.size_flag = true;
        return;
      } else {
        this.size_flag = false;
      }

      // Extension validation
      if (!this.allowed_extensions.includes(ext)) {
        this.ext_flag = true;
        return;
      } else {
        this.ext_flag = false;
      }

      // OPEN CROP DIALOG
      const reader = new FileReader();
      reader.onload = (e) => {
        this.cropImageSrc = e.target.result;
        this.currentType = type;
        this.cropDialog = true;
      };
      reader.readAsDataURL(image);
    },

    saveImage() {
      this.dialog_upload = true;
      let formData = new FormData();
      formData.append("files", this.profile_image);
      formData.append("sign_file", this.sign_image);
      formData.append("instid", this.instid);
      axios
        .post("/EmployeeProfile/uploadEmployeeProfileImage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.status == "SUCCESS") {
              // alert("Success")
              this.showSnackbar("#4caf50", res.data.status_reason); // show snackbar on success
              this.getData();
              this.profile_image = null;
              this.sign_image = null;
            } else {
              this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
              //alert(res.data.status_reason)
              this.getData();
            }
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.dialog_upload = false;
        });
    },

    cropImage() {
      const canvas = this.$refs.cropper.getCroppedCanvas();

      canvas.toBlob((blob) => {
        const croppedFile = new File([blob], "cropped.jpg", {
          type: "image/jpeg",
        });

        if (this.currentType === "profile") {
          this.profile_image = croppedFile;
        } else {
          this.sign_image = croppedFile;
        }

        this.cropDialog = false;
      }, "image/jpeg", 0.9);
    },
    
    startMove() {
      this.moving = true;

      document.addEventListener("mousemove", this.moveSquare);
      document.addEventListener("mouseup", this.stopMove);
    },

    moveSquare(e) {
      if (!this.moving) return;

      const container = this.$refs.imageContainer.getBoundingClientRect();

      let x = e.clientX - container.left - this.squareSize / 2;
      let y = e.clientY - container.top - this.squareSize / 2;

      const img = this.$refs.cropImage;

      // Limit inside image
      x = Math.max(0, Math.min(x, img.width - this.squareSize));
      y = Math.max(0, Math.min(y, img.height - this.squareSize));

      this.squareX = x;
      this.squareY = y;
    },

    stopMove() {
      this.moving = false;
      document.removeEventListener("mousemove", this.moveSquare);
      document.removeEventListener("mouseup", this.stopMove);
    },

    startResize(direction) {
      this.resizing = direction;
      document.addEventListener("mousemove", this.resizeCrop);
      document.addEventListener("mouseup", this.stopResize);
    },

    stopResize() {
      this.resizing = null;
      document.removeEventListener("mousemove", this.resizeCrop);
      document.removeEventListener("mouseup", this.stopResize);
    },

    applySquareCrop() {
      const img = this.$refs.cropImage;
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const scaleX = img.naturalWidth / img.width;
      const scaleY = img.naturalHeight / img.height;

      const cropX = this.cropLeft * scaleX;
      const cropY = this.cropTop * scaleY;
      const cropW = this.cropWidth * scaleX;
      const cropH = this.cropHeight * scaleY;

      canvas.width = cropW;
      canvas.height = cropH;

      ctx.drawImage(img,cropX,cropY,cropW,cropH,0,0,cropW,cropH);
      canvas.toBlob((blob) => {
        const croppedFile = new File([blob], "cropped.jpg", {
          type: "image/jpeg",
        });

        if (this.currentType === "profile") {
          this.profile_image = croppedFile;
        } else {
          this.sign_image = croppedFile;
        }
      });

      this.cropDialog = false;
    },
    
    resizeCrop(e) {
      if (!this.resizing) return;

        const img = this.$refs.cropImage;
        const rect = img.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;
        const minSize = 40;

        let newLeft = this.cropLeft;
        let newTop = this.cropTop;
        let newWidth = this.cropWidth;
        let newHeight = this.cropHeight;

        switch (this.resizing) {

          case "top":
            newHeight = this.cropHeight + (this.cropTop - mouseY);
            newTop = mouseY;
            if (newHeight < minSize) {
              newHeight = minSize;
              newTop = this.cropTop + this.cropHeight - minSize;
            }
            break;

          case "bottom":
            newHeight = mouseY - this.cropTop;
            if (newHeight < minSize) newHeight = minSize;
            break;

          case "left":
            newWidth = this.cropWidth + (this.cropLeft - mouseX);
            newLeft = mouseX;
            if (newWidth < minSize) {
              newWidth = minSize;
              newLeft = this.cropLeft + this.cropWidth - minSize;
            }
            break;

          case "right":
            newWidth = mouseX - this.cropLeft;
            if (newWidth < minSize) newWidth = minSize;
            break;

          case "top-left":
            newWidth = this.cropWidth + (this.cropLeft - mouseX);
            newHeight = this.cropHeight + (this.cropTop - mouseY);
            newLeft = mouseX;
            newTop = mouseY;

            if (newWidth < minSize) {
              newWidth = minSize;
              newLeft = this.cropLeft + this.cropWidth - minSize;
            }

            if (newHeight < minSize) {
              newHeight = minSize;
              newTop = this.cropTop + this.cropHeight - minSize;
            }
            break;

          case "top-right":
            newWidth = mouseX - this.cropLeft;
            newHeight = this.cropHeight + (this.cropTop - mouseY);
            newTop = mouseY;

            if (newWidth < minSize) newWidth = minSize;

            if (newHeight < minSize) {
              newHeight = minSize;
              newTop = this.cropTop + this.cropHeight - minSize;
            }
            break;

          case "bottom-left":
            newWidth = this.cropWidth + (this.cropLeft - mouseX);
            newLeft = mouseX;
            newHeight = mouseY - this.cropTop;

            if (newWidth < minSize) {
              newWidth = minSize;
              newLeft = this.cropLeft + this.cropWidth - minSize;
            }

            if (newHeight < minSize) newHeight = minSize;
            break;

          case "bottom-right":
            newWidth = mouseX - this.cropLeft;
            newHeight = mouseY - this.cropTop;

            if (newWidth < minSize) newWidth = minSize;
            if (newHeight < minSize) newHeight = minSize;
            break;
        }

        if (newLeft < 0) newLeft = 0;
        if (newTop < 0) newTop = 0;

        if (newLeft + newWidth > img.width) {
          newWidth = img.width - newLeft;
        }

        if (newTop + newHeight > img.height) {
          newHeight = img.height - newTop;
        }

        this.cropLeft = newLeft;
        this.cropTop = newTop;
        this.cropWidth = newWidth;
        this.cropHeight = newHeight;
      },
    },
  computed: {
    cropStyle() {
      return {
        position: "absolute",
        top: this.cropTop + "px",
        left: this.cropLeft + "px",
        width: this.cropWidth + "px",
        height: this.cropHeight + "px",
        border: "2px dotted red",
        boxSizing: "border-box"
      };
    }
}

  
};
</script>
<style scoped>
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
  font-size: 80%;
}
.crop-box {
  position: absolute;
}

.resize {
  position: absolute;
  background: transparent;
}

.resize.top {
  top: -5px;
  left: 0;
  width: 100%;
  height: 10px;
  cursor: ns-resize;
}

.resize.bottom {
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 10px;
  cursor: ns-resize;
}

.resize.left {
  left: -5px;
  top: 0;
  width: 10px;
  height: 100%;
  cursor: ew-resize;
}

.resize.right {
  right: -5px;
  top: 0;
  width: 10px;
  height: 100%;
  cursor: ew-resize;
}
/* .corner {
  position: absolute;
  width: 10px;
  height: 10px;
  background: red;
  z-index: 10;
} */

.corner {
  position: absolute;
  width: 20px; 
  height: 20px;
  z-index: 10;
}

.crop-box {
  position: absolute;
  border: 2px dotted red; 
  box-sizing: border-box;
}

.crop-box .corner {
  position: absolute;
  width: 20px;
  height: 20px;
  z-index: 10;
}

.crop-box .corner span {
  position: absolute;
  background-color: red;
}

.crop-box .corner .hor {
  height: 3px;
  width: 14px;
}

.crop-box .corner .ver {
  width: 3px;
  height: 14px;
}

.crop-box .corner.top-left .hor {
  top: 0;
  left: 0;
}
.crop-box .corner.top-left .ver {
  top: 0;
  left: 0;
}

.crop-box .corner.top-right .hor {
  top: 0;
  right: 0;
}
.crop-box .corner.top-right .ver {
  top: 0;
  right: 0;
}

.crop-box .corner.bottom-left .hor {
  bottom: 0;
  left: 0;
}
.crop-box .corner.bottom-left .ver {
  bottom: 0;
  left: 0;
}

.crop-box .corner.bottom-right .hor {
  bottom: 0;
  right: 0;
}
.crop-box .corner.bottom-right .ver {
  bottom: 0;
  right: 0;
}

.crop-box .corner.top-left {
  top: -4px;
  left: -4px;
  cursor: nwse-resize;
}

.crop-box .corner.top-right {
  top: -4px;
  right: -4px;
  cursor: nesw-resize;
}

.crop-box .corner.bottom-left {
  bottom: -4px;
  left: -4px;
  cursor: nesw-resize;
}

.crop-box .corner.bottom-right {
  bottom: -4px;
  right: -4px;
  cursor: nwse-resize;
}

</style>